<template>
  <div class="section" :class="(showForm) ? 'ck-new-accounting' : ''">
      <button class="button is-primary is-fullwidth" @click="toggleForm">
          <span v-if="showForm">Formular verbergen</span>
          <span v-if="!showForm">Neue Einnahme/Ausgabe <i class="has-margin-left-1 fa fa-plus"></i></span>
      </button>
      <div class="form has-padding-top-1 has-padding-left-1 has-padding-right-1" v-if="showForm">
      <div class="field is-horizontal">
          <label for="" class="has-margin-right-1">
              Neue Einnahme/Ausgabe für:
          </label>
          <div class="field-body">
              <div class="field has-addons">
                   <div class="control">
                      <div class="select is-fullwidth">
                          <select name="player" id="add_for_player" v-model="selected">
                              <option v-for="player in players" :value="player.id">{{ player.lastname}} {{ player.firstname }}</option>
                          </select>
                      </div>
                  </div>
                  <div class="control">
                      <a :disabled="selected == ''" :href="'/accountings/new/' + selected" class="button is-primary">Los</a>
                  </div>
              </div>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
    props: [],
    data: function() {
        return {
            players: [],
            selected: '',
            showForm: false
        }
    },
    beforeMount: function () {
        axios.get('/playerlist?noPaginate=true').then(res => {
            this.$data.players = res.data;
        })

        return;
    },
    methods: {
        toggleForm: function() {
            return this.showForm = !this.showForm
        }
    }
}
</script>

<style>
    .ck-new-accounting {
        outline: 1px solid #ddd;
        margin-bottom: 2rem;
    }
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/ckAddAccounting.vue